import { TwitterStyling } from '@/modules/layouts/classes'
import { BoxStylingBase } from '@/modules/layouts/classes/BoxStylingBase'
import { SceneSourceType } from '@/modules/scenes/types'
import { AssetType } from '@/types/assets'
import {
  BackdropMode, LayoutBoxType, CasterCSS, ChatCSS, LiveChatCSS, LayoutBoxField, TransitionType
} from '@/types/layouts'
import type { Layout } from '@/modules/layouts/classes'
import { LayoutBox } from '@/modules/layouts/classes'
import type { Scene } from '@/types/scenes'

const fullscreenBox = new LayoutBox({
  active: true,
  backdropMode: BackdropMode.None,
  field: LayoutBoxField.BACK,
  id: 'fullscreen',
  name: 'fullscreen',
  styling: new BoxStylingBase(),
  type: LayoutBoxType.BOX,
  types: [AssetType.Broadcast],
  zindex: 1
})

const createFullScreenLayout = (teamId: string) => {
  const layout: Layout = {
    name: 'fullscreen',
    info: 'fullscreen',
    boxes: {
      fullscreen: fullscreenBox
    },
    transition: {
      type: TransitionType.NONE,
      actions: []
    },
    castercss: new CasterCSS(),
    chatcss: new ChatCSS(),
    tweetcss: new TwitterStyling(),
    livechatcss: new LiveChatCSS(),
    simplecgcss: {},
    clips: {
      automute: false
    },
    team_id: teamId
  }
  return layout
}

export const createScene = (id: string, name: string, teamId: string, order: number): Scene => {
  const scene: Scene = {
    id,
    name,
    color: null,
    scenePresetIds: [],
    contents: {},
    scene_layout: createFullScreenLayout(teamId),
    sourceType: SceneSourceType.Generic,
    layout_id: 'fullscreen',
    order
  }
  return scene
}
